<template>
    <div style="position: relative;overflow:hidden">
        <img src="@/assets/images/strategy/background.png" alt class="bg1"/>
      
        <div class="container">
            <div class="tabs">
                <div 
                    v-for="(item, ind) in radioItem"
                    :key="ind"
                    @change="radioChange(ind, item)"
                >
                    <input type="radio" :id="'radio-'+ind" name="tabs" :class="{ checked: radioActive == ind }"/>
                    <label class="tab" :for="'radio-'+ind" :class="{ checked: radioActive == ind }">{{item.title}}</label>
                </div>
                <span class="glider" :style="radioStyle"></span>
        
            </div>
        </div>
        <img src="@/assets/images/strategy/background.png" alt class="bg2"/>
        <div class="tableBlock">
            <!-- element-loading-text="加载数据中，请耐心等待1-5分钟"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#FFFFFF" -->
            <el-table :data="tableData" class="tableStyle" 
            v-loading="tableLoading"  
            :header-cell-style="{'background': '#DBDBFA','height':'50px','text-align': 'left',
            'font-size': '14px','font-weight': 400,'color': '#333333','font-weight':'bold'}">
                <el-table-column label="策略类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.strategyType  == 1">首购转化</span>
                        <span v-if="scope.row.strategyType  == 2">老客招募</span>
                        <span v-if="scope.row.strategyType  == 3">复购召回</span>
                        <span v-if="scope.row.strategyType  == 4">流失激活</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="策略名称"></el-table-column>
                <el-table-column prop="activityType" label="活动类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==3">{{ jdkToName[scope.row.activityType] }}</span>
                        <span v-else>{{ idToName[scope.row.activityType] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="activityName" label="活动名称" width="270px"></el-table-column>
                <el-table-column prop="activityCreateTime" label="创建时间"  width="200px"></el-table-column>
                <el-table-column prop="activityTime" label="活动时间" width="200px"></el-table-column>
                <el-table-column prop="activityStatus" label="活动状态" ></el-table-column>
                <el-table-column label="效果数据">
                    <template slot-scope="scope">
                        <span style="font-size: 14px;color: #999999;" 
                            v-if="scope.row.type == 1 && scope.row.activityStatus !== '已发送'">查看
                        </span>
                        <span style="font-size: 14px;color: #999999;" 
                            v-else-if=" scope.row.type == 2 && scope.row.activityStatus !== '已发送' &&  scope.row.activityType > 60 && scope.row.activityType < 66  ">查看
                        </span>
                        <span style="font-size: 14px;color: #999999;" 
                            v-else-if=" scope.row.type == 2 && scope.row.isHideView == 1 &&  scope.row.activityType > 69 && scope.row.activityType < 85 ">查看
                        </span>
                        <span style="font-size: 14px;color: #6461E7;cursor: pointer;" @click="routerLink(scope.row)" v-else>查看</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;margin: 25px 0 0 0;">
                <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.current"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="form.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                ></el-pagination>
            </div>
        </div>
    
    </div>
</template>
    
<script>
import {
	mineStrategy,getSeller,toJHK
} from "@/api/industry/strategy.js";
import idToUrlObj from "../idToUrl.js"
import idToName from "../idToName.js"
import jdkToName from "../jdkToName.js"
export default {
name: '' ,
components: {},
props:{},
data() {
return {
    radioItem:[
        {
            title:'全部'
        },
        {
            title:'首购转化'
        },
        {
            title:'老客招募'
        },
        {
            title:'复购召回'
        },
        {
            title:'流失激活'
        }
    ],
    radioActive:0,
    form: {
        strategyType:'',
        size: 10,
        current: 1	
    },
    tableData: [],
    tableLoading: false,
    total: 0,
    idToName:idToName,
    jdkToName:jdkToName,
    isOrderHd:false,//京获客资格
}
},
computed: {
    radioStyle() {
      return {
        transform:`translateX( ${this.radioActive*100}%)`
      };
    },
},
created() {

},
mounted() {
    this.getStrategy(0)
    this.getSellers()
},
methods: {
    //获取京获客资格
    getSellers(){
        getSeller().then(res => {
            if (res.code == 1) {
                this.isOrderHd = res.data.isOrderHd
            }else{
                this.$message.warning(res.message)
            }
        })
    },
    // 获取数据
    getStrategy(){
        this.tableLoading = true
        if(this.radioActive == 0){
            this.form.strategyType= ' '
        }else{
            this.form.strategyType= this.radioActive 
        }
        console.log("form--",this.form)
        mineStrategy(this.form).then((res) => {
        this.tableLoading = false
        if(res.code === 1){
            this.tableData = res.data.records
            this.total = res.data.total
            
        }else{
            this.$message.warning(res.message);
        }
      });
    },
    radioChange(ind, item){
        this.radioActive = ind;
        this.form.size = 10;
        this.form.current = 1;
        this.getStrategy(ind)
    },
    handleSizeChange(size) {
      this.form.size = size;
      this.getStrategy();
    },
    handleCurrentChange(current) {
      this.form.current = current;
      this.getStrategy();
    },
    //跳转
    routerLink(item) {
      console.log("点击的item",item)
      let _query = {}
      let id =  Number(item.activityType)
      if(item.type == 2 || item.type == 1){
        //系统部分
        if( id > 69 && id< 85){
        let time = item.activityTime.split("~");
        _query={
          outerId: item.outId,
          source: "AUTO_MARKETING",
          activityEndTime: time[1],
          activityStartTime: time[0],
        }
        }else if( (id > 50 && id< 55) || (id > 40 && id< 44) || id <= 14 || id == 24){
            //订单关怀
            _query={
                industry:1
            }
        }else if( (id > 14 && id< 21) || id ==25){
            //自动化营销
            _query={
                industry:2
            }
        }else if(id == 66){
            //咚咚群聊
            _query={
                industry:3
            }
        }else if(id > 60 && id<66){
            //精准营销
            if(id==61){
                _query={
                    outerId: item.outId,
                    source: "PRECISION_MARKETING",
                    sendTime: item.activityTime,
                    // smsType: item.smsType,
                }
            }else if(id == 62){
                _query={
                    outerId: item.outId,
                    source: "INTELLIGENT_MARKETING",
                    sendTime: item.activityTime,
                }
            }else if(id ==63){
                _query={
                    outerId: item.outId,
                    source: "PACKAGE_SEND",
                    sendTime: item.activityTime,
                }
            }else if(id == 64){
                _query={
                    outerId: item.outId,
                    source: "PACKAGE_SEND",
                    sendTime: item.activityTime,
                }
            }else if(id==65){
                _query={
                    outerId: item.outId,
                    source: "PACKAGE_SEND",
                    sendTime: item.activityTime,
                    // smsType: item.smsType,
                }
            }else{
                _query={industry:4}
            }
        }

        let routeUrl = this.$router.resolve({
        path: idToUrlObj[id],
        query:_query,
        });
        window.open(routeUrl.href, "_blank");
      }else if(item.type =3){
        //京获客
        // let jhk_link = 'https://jdtest.yucrm.cn/integralCenter/activityManage'+'?outId='+item.outId
        // 线上
        // let jhk_link = 'http://jdhd.tj9.co/integralCenter/activityManage'+'?outId='+item.outId
        // window.open(jhk_link, "_blank");
        
        //先判断是否有购买jhk
        if(this.isOrderHd){
            //线上
            let url='http://jdhd.tj9.co/integralCenter/activityManage'+'?outId='+item.outId+'&activityType='+item.activityType
            //测试环境
            // let url = 'https://jdtest.yucrm.cn/integralCenter/activityManage'+'?outId='+item.outId+'&activityType='+item.activityType
            toJHK({url:url}).then(res => {
                if (res.code == 1) {
                    let jhk_link = res.data
                    window.open(jhk_link, "_blank");
                }else{
                    this.$message.warning(res.message)
                }
            })
        }else{
            //没有买jhk或者过期
            window.open("/jhkGuide", "_blank");
            // this.buriedPoint(1, "引导订购京获客页面", "行业专区", "我的使用策略");
        }
      }
      
    },
}
}
</script>
<style lang='scss'>
.tableBlock{
    .el-loading-spinner .path{
        stroke: #6461E7 !important;
    }
    .el-loading-spinner i{
     color: #666666 !important;
     font-size: 20px;
    }
    .el-loading-spinner .el-loading-text{
        color: #666666 !important;
        padding: 10px 0 ;
        font-size: 16px;
    }
}
</style>
<style lang='scss' scoped>
// 导航栏
*,
*:after,
*:before {
  box-sizing: border-box;
}
 
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  width: 743px;
  height: 50px;
  margin: 30px auto 30px; 
  background: #FBFBFF;
  border-radius: 25px;
}

.bg1{
    position: absolute;
    top: 0;
    right: 0;
    width: 426px;
    height: 434px;
}


.bg2{
    position: absolute;
    left: 0px;
    width: 426px;
    height: 434px;
}
 
.tabs {
  display: flex;
  position: relative;
  background: #F1F1FF;
  padding: 8px;
  border-radius: 25px;
  margin: 30px 0 ;
}
.tabs * {
  z-index: 2;
}
 
input[type=radio] {
  display: none;
}
 
.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  border-radius: 99px;
  cursor: pointer;
  transition: color 0.15s ease-in;
  width: 145px;
  height: 34px;
  line-height: 32px;

}

.tab.checked{
    color: #ffffff;
}

input[type=radio]:checked + label {
  color: #ffffff;
}

.glider {
  position: absolute;
  display: flex;
  background: #6461E7;
  border-radius: 17px 17px 17px 17px;
  z-index: 1;
  transition: 0.25s ease-out;
  width: 145px;
  height: 34px;
}
 
@media (max-width: 700px) {
  .tabs {
    transform: scale(0.6);
  }
}

// 表格
.tableBlock{
    position: relative;
    width: 1200px;
    margin: 0 auto;
}
.tableStyle{
    background: #FFFFFF;
    box-shadow: 0px 3px 30px 0px rgba(100,97,231,0.1);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
}
/deep/.el-table th.el-table__cell > .cell{
    padding-left: 23px;
    line-height: 40px !important;
    font-weight: 400;
}
/deep/.el-table .cell{
    line-height: 18px !important;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
    
    background: #6461E7;
}
/deep/ .el-pagination.is-background .el-pager li{
    min-width: 32px;
}
/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell{
    padding-left: 13px !important;
}
</style>